import React, { FC } from 'react'
import { FooterSocial } from './FooterSocial/FooterSocial'
import { FooterPropsType } from './Footer.types'
import { FooterNav } from './FooterNav/FooterNav'
import { FooterGenericNav } from './FooterGenericNav/FooterGenericNav'
import './footer.scss'

export const Footer: FC<FooterPropsType> = props => {
  const {
    socialFooter,
    navFooter,
    genericFooterMenu,
  } = props.content

  return (
    <div className='u-adel-reset u-paddingBottom6gu'>
      <FooterSocial {...socialFooter} />
      <FooterNav {...navFooter} />
      <FooterGenericNav {...genericFooterMenu} />
    </div>
  )
}
